import React, { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { UserPlus } from "lucide-react";
import api from "../lib/api";

const CARD = "bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)]";

const Total = ({ label, value, color, testid }) => (
  <div className="rounded-xl px-4 py-2" style={{ background: `${color}14` }} data-testid={testid}>
    <div className="font-head text-2xl font-extrabold" style={{ color }}>{value}</div>
    <div className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: "var(--sj-text-3)" }}>{label}</div>
  </div>
);

const FollowThrough = ({ f }) => (
  <div className="rounded-xl px-4 py-2 border-2" style={{ borderColor: "#0B5E4E33" }} data-testid="signup-follow-through"
    title="First time members reached by Pastoral Care (call/visit 'Spoke / reached' or text 'Replied') within 7 days of signing up">
    <div className="font-head text-2xl font-extrabold" style={{ color: "var(--sj-primary)" }} data-testid="signup-follow-through-pct">{f.pct == null ? "—" : `${f.pct}%`}</div>
    <div className="text-[11px] uppercase tracking-wider font-semibold" style={{ color: "var(--sj-text-3)" }}>Reached in 7 days</div>
    <div className="text-[11px]" style={{ color: "var(--sj-text-3)" }} data-testid="signup-follow-through-count">{f.reached_7d} of {f.due} first time members</div>
  </div>
);

export const SignupReport = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard/signup-report", { params: { months: 12 } }).then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <div className={`${CARD} p-6`} data-testid="signup-report">
      <div className="flex flex-wrap items-start gap-4 mb-4">
        <div className="flex-1 min-w-[12rem]">
          <h3 className="font-head text-xl font-semibold flex items-center gap-2"><UserPlus className="h-5 w-5" style={{ color: "var(--sj-primary)" }} /> Portal sign-ups</h3>
          <p className="text-sm" style={{ color: "var(--sj-text-2)" }}>First time members, visitors and people who already attend — last 12 months</p>
        </div>
        <Total label="First time member" value={data.totals.new} color="#0B5E4E" testid="signup-total-new" />
        <Total label="Just visiting" value={data.totals.visiting} color="#17A88A" testid="signup-total-visiting" />
        <Total label="Already attend" value={data.totals.active} color="#B8860B" testid="signup-total-active" />
        <FollowThrough f={data.follow_through} />
      </div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data.rows} margin={{ left: -20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#EBE9E4" vertical={false} />
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#56626A" }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#56626A" }} />
          <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #EBE9E4" }} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar name="First time member" dataKey="new" stackId="s" fill="#0B5E4E" />
          <Bar name="Just visiting" dataKey="visiting" stackId="s" fill="#17A88A" />
          <Bar name="Already attend" dataKey="active" stackId="s" fill="#E0B100" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
